
import { DocumentLayoutLogoPosition } from "@/utils/documents/layout-logo";
import { ReminderLayout } from "@/utils/reminder-layouts/reminder-layout";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	props: {
		fancy: Boolean,
		label: String,
		value: String as () => DocumentLayoutLogoPosition,
		includeNone: Boolean,
		fullControl: Boolean,
		layout: {
			type: Object as ()=>ReminderLayout,
			required: true
		},
		disabled: Boolean
	},
	computed: {
		items(): ISelectItem<DocumentLayoutLogoPosition | "null">[] {
			let result: ISelectItem<DocumentLayoutLogoPosition | "null">[] = [];
			if (this.includeNone) {
				result = [{
					text: this.$ct("notPlaced").toString(),
					value: "null"
				}];
			}
			result.push({
				text: this.$ct("header").toString(),
				value: "Heading"
			});
			if (this.fullControl) {
				result.push(
					{
						text: this.$ct("body").toString(),
						value: "Body"
					},
					{
						text: this.$ct("footer").toString(),
						value: "Footer"
					},
				);

			}
			return result;
		},
	},
	methods: {
		onInput(value: DocumentLayoutLogoPosition | "null") {
			this.$emit("input", value);
		}
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
